import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, branch, renderComponent, withState, lifecycle } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import History from '@material-ui/icons/History';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import avatar from '../assets/avatar.jpg';

import {
  learnerVersionsRequest,
  printReportRequest,
  resetLearnerVersion,
} from '../redux/reducers/savedVersions';
import { selectUserVersion, selectUser } from '../redux/reducers/userProgramsFull';
import * as moment from 'moment';

import Spinner from './Spinner';
import { commonStyles } from '../styles/styles';
import iconPrint from '../assets/icon_print.svg';
import { convertTime } from '../utils';
import IframePopup from './Popups/IframePopup';
import {getUsersForProgram, selectedProgram, getPrograms, getProgramsForCoach, getUsersForRollout} from '../redux/selectors'

import { MDBCard, 
  MDBCardBody, 
  MDBCardTitle, 
  MDBCardText, 
  MDBCardHeader, 
  MDBBtn, 
  MDBContainer, 
  MDBTabPane, 
  MDBTabContent, 
  MDBNav, 
  MDBNavItem, 
  MDBNavLink, 
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBBadge} from "mdbreact";
import { toggleAddProgrammePopup, toggleAddUserPopup, toggleDeleteUserPopup } from '../redux/reducers/view';
import { getUserRolloutRequest } from '../redux/reducers/addUser';
import { STORAGE_LINK } from '../constants';



const CoachUsersList = ({
  classes,
  savedVersions,
  handlePrint,
  handleClickUser,
  handlePopupToggle,
  isShowPopup,
  users,
  toggleAddUserPopup,
  handleOpenDeleteUserPopup
}) => {
  

  const getButtonAction = (action, item) => {
    var btn = null
    switch (action) {
      case 'draft':
        btn = <MDBBtn className="table-btn noShadow w-100" size="sm" color="warning"  onClick={() => handleClickUser(item)}>RESTORE</MDBBtn>
        break;
      case 'Reviewed':
        btn = <MDBBtn className="table-btn noShadow w-100" size="sm" color="success"  onClick={() => handleClickUser(item)}>VIEW</MDBBtn>
        break;
      case 'Pending':
        btn = <MDBBtn className="table-btn noShadow w-100" size="sm" color="danger-dark" onClick={() => handleClickUser(item)}>VIEW</MDBBtn>
        break;
      case 'completed':
        btn = <MDBBtn className="table-btn noShadow w-100" size="sm" color="info">SHARE WITH COACH</MDBBtn>
        break;
      default:
        btn = <MDBBtn className="table-btn noShadow w-100" size="sm" color="danger-dark" disabled>WAITING</MDBBtn>
        break;
    }
      // if(content.type!=='Assignments'){
      //   return false;
      // }else{
        return btn;
      //}
     
    };

    const getStatus = action => {
      var btn = null
      switch (action) {
        case 'draft':
          btn = <MDBBadge className="noShadow" style={{padding: 5, fontSize:9, borderRadius:'0.25rem'}} color="warning-light">DRAFT</MDBBadge>
          break;
        case 'Reviewed':
          btn = <MDBBadge className="noShadow" style={{padding: 5, fontSize:9, borderRadius:'0.25rem'}} color="success-light">REVIEWED</MDBBadge>
          break;
        case 'Pending':
          btn = <MDBBadge className="noShadow" style={{padding: 5, fontSize:9, borderRadius:'0.25rem'}} color="danger-light">PENDING</MDBBadge>
          break;
        case 'completed':
          btn = <MDBBadge className="noShadow" style={{padding: 5, fontSize:9, borderRadius:'0.25rem'}} color="info-light">COMPLETED</MDBBadge>
          break;
        default:
          btn = <MDBBadge className="noShadow" style={{padding: 5, fontSize:9, borderRadius:'0.25rem'}} color="danger-light">WAITING</MDBBadge>
          break;
      }
        // if(content.type!=='Assignments'){
        //   return false;
        // }else{
          return btn;
        //}
       
      };
  console.log('CALLME', users)
  if (users) {
    const renderVersions = (item) => {
      
      return (
        
          <MDBRow className="table-row w-100 small-copy" style={{width:'100%', margin: '0 auto', paddingRight:0}}>
            <MDBCol className="table-col pl-2 leftAlign col-lg-3" > <div style={{position: 'relative', float:'left'}}>
                          {item.avatar ? <img src={STORAGE_LINK+item.avatar} className="rounded-circle z-depth-0"
                            style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px", marginRight: 10, zIndex: 1, top: -5}} alt="" />
                        : <img src={avatar} className="rounded-circle z-depth-0"
                        style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px", marginRight: 10, zIndex: 1, top: -5}} alt="" />
                          }
                      </div><p style={{float:'left', paddingLeft: 10 + 'px !important'}}> {item.firstname+' '+item.lastname}</p></MDBCol>
            <MDBCol className="table-col"><div className="xs-copy-ptsans"><p>
              <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round danger-color-border noShadow"  color="danger-color">{item.thinktools && item.thinktools.length}</MDBBadge></p></div> 
            </MDBCol>
            <MDBCol className="table-col"> <div className="xs-copy-ptsans"><p>
              <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round noShadow"  color="badge-success-light">{item.u_instancePending}</MDBBadge>
              </p></div> </MDBCol>
            <MDBCol className="table-col col-lg-2"><p><MDBIcon className="pr-2" far icon="calendar" />{moment(item.u_lastAccessed).format('YYYY/MM/DD')}</p></MDBCol>
            {/* <MDBCol className="table-col"> 
              <p>
              <div className="mailBadge m-0" onClick={()=>this.props.showMessageCenter(true)}>
                <MDBIcon style={{fontSize: '1.3rem', color: '#3EAE69'}} far icon="envelope" className="ml-1" size="lg" />
                <MDBBadge style={{left: '50%'}} className="badge-white badge-sm-pill-round ">{item.numberOfUnreadMessages}</MDBBadge>
              </div>
              </p>
            </MDBCol> */}
            <MDBCol className="table-col col-lg-1 p-0"><p>{getStatus(item.u_status)}</p></MDBCol>
            <MDBCol className="col-2 table-col col-lg-2 no-border mr-0 pr-0 mt-2">
            <div style={{width:'70%', float:'left'}}>
              {getButtonAction(item.u_status, item)}
            </div>
            <div style={{float:'right', cursor:'pointer'}}  className=" mt-1 mr-0" onClick={()=>handleOpenDeleteUserPopup(item)}>
              <MDBIcon  style={{fontSize: '1.3rem', color: '#F8D7DA'}} icon="times-circle" className="ml-1" size="lg" />
            </div>
            </MDBCol>
        
            </MDBRow>
          
      );
      };
      const renderVersionsMedium = (item) => {
      
        return (
         <MDBCard style={{minHeight: 'auto'}}>
            <MDBRow className="table-row w-100 small-copy" style={{width:'100%', margin: '0 auto'}}>
              <MDBCol className="table-col pl-2 col-8 no-border">
              <div style={{position: 'relative', float:'left'}}>
                    {item.avatar ? <img src={STORAGE_LINK+item.avatar} className="rounded-circle z-depth-0"
                      style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px", padding: 0, marginRight:10, zIndex: 1, top: -5}} alt="" />
                  : <img src={avatar} className="rounded-circle z-depth-0"
                  style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px", padding: 0, marginRight:10, zIndex: 1, top: -5}} alt="" />
                    }
                </div>
                <div className="pt-2 pb-2">
                  <b style={{float:'left', paddingLeft: 10 + 'px !important'}}> {item.firstname+' '+item.lastname}</b>
                </div>
                <div style={{clear: 'both', marginBottom:10}}></div>
                <div style={{width:'50%', textAlign:'left', float:'left'}}>
                 <div style={{display:'inline-block'}} className="small-copy-ptsans">
                  <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round danger-color-border "  color="danger-color">{item.thinktools && item.thinktools.length}</MDBBadge>
                  </div>
                  <div style={{display:'inline-block'}}  className="small-copy">Thinktools</div>
                </div>
                <div style={{width:'50%', textAlign:'left', float:'right'}}>
                  <div style={{display:'inline-block'}}  className="xs-copy-ptsans">
                  <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round danger-color-border  noShadow"  color="badge-success-light">{item.u_instancePending}</MDBBadge>
                  </div>
                  <div style={{display:'inline-block'}} className="small-copy">Pending</div>
                </div>
                <div style={{clear: 'both'}}></div>
                <div  style={{marginTop:10, float:'left', marginLeft:6}}>
                  <MDBIcon style={{paddingRight: 7}} far icon="calendar" />{moment(item.u_lastAccessed).format('YYYY/MM/DD')}
                </div>
              </MDBCol>
              <MDBCol className="table-col pl-2 no-border col-4">
                <div style={{float:'right', paddingLeft:10, marginTop:10}}>
                {getStatus(item.u_status)}
                </div>
                <div style={{clear: 'both', marginBottom:15}}></div>
                <div style={{width:'100%',float:'left', textAlign:'center'}}  className=" mt-1 mr-0" onClick={()=>handleOpenDeleteUserPopup(item)}>
                  <MDBIcon  style={{fontSize: '1.5rem', color: '#F8D7DA'}} icon="times-circle" className="ml-1"  />
                </div>
                {/* <div style={{width:'50%',textAlign:'left', float:'right'}}>
                  <div className="mailBadge mt-2 ml-0 mr-0 mb-0" onClick={()=>this.props.showMessageCenter(true)}>
                    <MDBIcon style={{fontSize: '1.3rem', color: '#3EAE69'}} far icon="envelope" className="ml-1" size="lg" />
                    <MDBBadge style={{left: '50%'}} className="badge-white badge-sm-pill-round">{item.unreadMsgs}</MDBBadge>
                  </div>
                </div> */}
                
                <div style={{position:'absolute', right:0, bottom: 0, width:'100%', textAlign:'right'}}>
                  {getButtonAction(item.u_status, item)}
                </div>
              </MDBCol>
            </MDBRow>
        </MDBCard>
        );
        };
      const renderVersionsSmall = (item) => {
      
        return (
          <MDBCard  style={{minHeight: 'auto'}}>
            <MDBRow className="table-row w-100 small-copy" style={{width:'100%', margin: '0 auto'}}>
              <MDBCol className="table-col pl-2 col-9 no-border">
              <div style={{position: 'relative', float:'left'}}>
                    {item.avatar ? <img src={STORAGE_LINK+item.avatar} className="rounded-circle z-depth-0"
                      style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px", padding: 0, marginRight:10, zIndex: 1, top: -5}} alt="" />
                  : <img src={avatar} className="rounded-circle z-depth-0"
                  style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px", padding: 0, marginRight:10, zIndex: 1, top: -5}} alt="" />
                    }
                </div>
                <div className="pt-2 pb-2">
                  <b style={{float:'left', paddingLeft: 10 + 'px !important'}}> {item.firstname+' '+item.lastname}</b>
                </div>
                <div style={{clear: 'both', marginBottom:10}}></div>
                <div style={{width:'50%', textAlign:'left', float:'left'}}>
                 <div style={{display:'inline-block'}} className="small-copy-ptsans">
                  <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round danger-color-border "  color="danger-color">{item.thinktools && item.thinktools.length}</MDBBadge>
                  </div>
                  <div style={{display:'inline-block'}}  className="small-copy">Thinktools</div>
                </div>
                <div style={{width:'50%', textAlign:'left', float:'right'}}>
                  <div style={{display:'inline-block'}}  className="xs-copy-ptsans">
                  <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round danger-color-border "  color="badge-success-light">{item.u_instancePending}</MDBBadge>
                  </div>
                  <div style={{display:'inline-block'}} className="small-copy">Pending</div>
                </div>
                <div style={{clear: 'both'}}></div>
                <div  style={{marginTop:10, float:'left', marginLeft:6}}>
                  <MDBIcon style={{paddingRight: 7}} far icon="calendar" />{moment(item.u_lastAccessed).format('YYYY/MM/DD')}
                </div>
              </MDBCol>
              <MDBCol className="table-col p-0 no-border col-3">
                <div style={{float:'right', paddingLeft:10, marginTop:10}}>
                {getStatus(item.u_status)}
                </div>
                <div style={{clear: 'both', marginBottom:15}}></div>
               
                {/* <div style={{width:'60%',textAlign:'left', float:'right'}}>
                  <div className="mailBadge mt-2 ml-0 mr-0 mb-0" onClick={()=>this.props.showMessageCenter(true)}>
                    <MDBIcon style={{fontSize: '1.3rem', color: '#3EAE69'}} far icon="envelope" className="ml-1" size="lg" />
                    <MDBBadge style={{left: '50%'}} className="badge-white badge-sm-pill-round">{item.unreadMsgs}</MDBBadge>
                  </div>
                </div> */}
                <div style={{width:'100%',float:'right', marginTop:-6, textAlign:'center'}}  className="mr-0" onClick={()=>handleOpenDeleteUserPopup(item)}>
                  <MDBIcon  style={{fontSize: '1.8rem', color: '#F8D7DA'}} icon="times-circle" className="ml-1"  />
                </div>
                <div style={{position:'absolute', right:0, bottom: 0, width:'100%', textAlign:'right'}}>
                  {getButtonAction(item.u_status, item)}
                </div>
              </MDBCol>
            </MDBRow>
        </MDBCard>
        );
        };
    return (
     
      <div>
    <MDBCard  className="z-depth-2 rounded-0 d-none d-lg-block yellow-card" style={{height:"100%"}}>
    <div className='gothamBlack text-dark text-left pt-3 pl-3'>
      USERS
    </div>
    <MDBBtn
            floating
            style={{position: 'absolute', right: 0, top: 0}}
            tag='a'
            className='ml-auto ml-4 '
            action
            onClick={()=>toggleAddUserPopup(true)}
          >
            <MDBIcon icon='plus' className="default-color" size="md"/>
          </MDBBtn>
    <div style={{height:1, backgroundColor:'#CCCCCC', marginTop:12}}></div>
      <div style={{backgroundColor: '#ffffff'}}>
      <MDBRow className="w-100 pt-2 pb-2 pr-0 mr-0" style={{fontSize: '0.7rem', margin: '0 auto', backgroundColor:'#EBEBEB'}}>
          <MDBCol className="center col-3">User</MDBCol>
          <MDBCol className="center ">ThinkTools</MDBCol>
          <MDBCol className="center ">Pending</MDBCol>
          <MDBCol className="center col-2 ">Last Accessed</MDBCol>
          {/* <MDBCol className="center ">Messages</MDBCol> */}
          <MDBCol className="center ">Status</MDBCol>
          <MDBCol className="center col-2 mr-0 pr-0  ">Actions</MDBCol>
      </MDBRow>
      <div className="contentScrollTable">
        {users.map((item, idx) => (
        renderVersions(item)
        ))}
      </div>
    </div>

</MDBCard>
<MDBCard  className="z-depth-2 rounded-0 d-none d-md-block d-lg-none yellow-card" style={{height:"100%"}}>
    <div className='gothamBlack text-dark text-left pt-3 pl-3'>
        USERS
    </div>

    <MDBBtn
            floating
            style={{position: 'absolute', right: 0, top: 0}}
            tag='a'
            className='ml-auto ml-4 '
            action
            onClick={()=>toggleAddUserPopup(true)}
          >
            <MDBIcon icon='plus' className="success-color" size="md"/>
          </MDBBtn>
    <div style={{height:1, backgroundColor:'#CCCCCC', marginTop:12}}>
    
    </div> 
      <div className="contentScrollTable">
      {users.map((item, idx) => (
      renderVersionsMedium(item)
      ))}
      </div>

</MDBCard>

<MDBCard  className="z-depth-2 rounded-0  d-md-none yellow-card" style={{height:"100%"}}>
  <div className='gothamBlack text-dark text-left pt-3 pl-3'>
        USERS
        </div>
        <MDBBtn
            floating
            style={{position: 'absolute', right: 0, top: 0}}
            tag='a'
            className='ml-auto ml-4 '
            action
            onClick={()=>toggleAddUserPopup(true)}
          >
            <MDBIcon icon='plus' className="success-color" size="md"/>
          </MDBBtn>  
    <div style={{height:1, backgroundColor:'#CCCCCC', marginTop:12}}></div>
      <div className="contentScrollTable">
      {users.map((item, idx) => (
      renderVersionsSmall(item)
      ))}
      </div>

</MDBCard>
        {/* {savedVersions.learnerVersions.reverse().map((item, idx) => (
          <div className={classes.versionItem} key={idx.toString()}>
            <div className={classes.itemLeft}>
              <p className={classes.versionName}>{item.name}</p>
              <History className={classes.itemIcon} />
              <span className={classes.versionDate}>{convertTime(item.updated_at.date)}</span>
            </div>
            {item.progressPercentage && (
              <div className={classes.itemPercentage}>{`${item.progressPercentage}%`}</div>
            )}
            <div className={classes.itemRight}>
              <div className={classes.itemLink}>
                
                <img src={iconPrint} alt="print" onClick={() => handlePrint(item.versionId)} />
               
              </div>
              <Button
                className={`${classes.defaultButton} ${classes.buttonVersions}`}
                variant="raised"
                onClick={() => handleClickVersion(item.path, item.versionId)}
              >
                RESTORE
              </Button>
            </div>
          </div>
        ))} */}
        {isShowPopup &&
          savedVersions.versionsPdf && (
            <IframePopup
              handlePopupToggle={handlePopupToggle}
              pathToIframeFile={savedVersions.versionsPdf.path}
              selectedContentItem={{ type: 'Document' }}
              contentIframe={false}
            />
          )}
      </div>
    );
  }
  return <Typography className={classes.text}>{savedVersions.error}</Typography>;
};

const styles = () => ({
  ...commonStyles,
});

const mapStateToProps = state => ({
  versions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  users: getUsersForRollout(state),
  savedVersions: state.savedVersionsReducer,
});

const mapDispatchToProps = dispatch => ({
  printReportRequest: versionId => dispatch(printReportRequest(versionId)),
  selectUser: userId => dispatch(selectUser(userId)),
  learnerVersionsRequest: () => dispatch(learnerVersionsRequest()),
  resetLearnerVersion: () => dispatch(resetLearnerVersion()),
  toggleAddProgrammePopup: value => dispatch(toggleAddProgrammePopup(value)),
  toggleAddUserPopup: value => dispatch(toggleAddUserPopup(value)),
  toggleDeleteUserPopup: value => dispatch(toggleDeleteUserPopup(value)),
  getUsersForRollout:() => dispatch(getUserRolloutRequest())
});

export default compose(
   withRouter,
  withState('isShowPopup', 'togglePopup', false),
  withState('startTime', 'setStartTime', null),
  withState('stopTime', 'setStopTime', null),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handlePrint: props => value => {
      props.selectUserVersion(value);
      props.printReportRequest(value);
      props.togglePopup(true);
    },
    handlePopupToggle: props => () => {
      props.togglePopup(false);
    },
    handleClickUser: props => (item) => {
      
      props.selectUser(item.user_id);
      props.history.push(
        `/users/${props.userProgramsFull.selectedProjectId}/${props.userProgramsFull.selectedRollout}/${item.user_id}`+ props.history.location.search,
      );
    },
    handleOpenDeleteUserPopup: props => item => {
      props.selectUser(item.user_id);
      props.toggleDeleteUserPopup(true);
  
    },
  }),
  lifecycle({
    componentWillMount() {
      console.log('PPPPPPPQ')
     // this.props.getUsersForRollout()
    },
  }),
  withStyles(styles),
)(CoachUsersList);

CoachUsersList.propTypes = {
  classes: PropTypes.instanceOf(Object),
  savedVersions: PropTypes.instanceOf(Object),
  handlePrint: PropTypes.func,
  handleClickVersion: PropTypes.func,
  handlePopupToggle: PropTypes.func,
  isShowPopup: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/Components/CoachUsersList.jsx